
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"23","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"color",attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M22.439 6.695c.748.72.748 1.89 0 2.61l-6.39 6.154c-.748.721-1.961.721-2.71 0a1.799 1.799 0 010-2.61l3.117-3.003H1.916C.859 9.846 0 9.02 0 8s.858-1.846 1.917-1.846h14.54l-3.118-3.002a1.799 1.799 0 010-2.611 1.969 1.969 0 012.71 0l6.39 6.154z","fill":"#A3A3A3"}})])
          )
        }
      }
    